import { EvaluatedUser } from './evaluated-user.interface';

export interface MidYearEvaluation {
    id?: number;
    cycleParticipantId: number;
    creationUserId: string;
    subjectUser?: EvaluatedUser;
    subjectUserId: string;
    createdAt: string;
    field1: string;
    field2: string;
    field3: string;
    field4: string;
    field5: string;
    field6: string;
    field7: string;
    field8: string;
    field9: string;
    field10: string;
    status: FreeEvaluationStatus;
    sentDate?: Date;
}

export enum FreeEvaluationStatus {
    NotSent = 0,
    Sent = 1
}
